import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class ImageProcessingService {

  constructor() { }

  public imageElementToDataURI(imageElement: HTMLImageElement): string {
    const canvas = document.createElement('canvas');
    canvas.width = imageElement.naturalWidth;
    canvas.height = imageElement.naturalHeight;
    const context = canvas.getContext('2d');
    context.drawImage(imageElement, 0, 0);
    return canvas.toDataURL();
  }

  public dataURItoBlob(dataURI: string): Blob {
    const {data, content_type} = this.dataURLtoObject(dataURI);
    const byteString = atob(data);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const splitMimeType = content_type.split('/');
    const fileExtension = splitMimeType[splitMimeType.length - 1];
    return new Blob([ab], {type: content_type});
  }

  public dataURLtoObject(dataURI: string): { data: string, content_type: string } {
    const s = dataURI.split(',');
    if (s[0].indexOf('base64') >= 0) {
      const data = dataURI.split(',')[1];
      // separate out the mime component
      const mimeString = s[0].split(':')[1].split(';')[0];
      return {data: data, content_type: mimeString};
    } else {
      throw new Error('Cannot find comma in data url');
    }
  }

  public fileToDataURI(file: File): Observable<string> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onload = () => {
        observer.next(reader.result as string);
        observer.complete();
      };
      reader.onerror = (error) => {
        throw error;
      };
      reader.readAsDataURL(file);
    });
  }
}
